import React from 'react'
import clsx from 'clsx';
import { LeftArrowWhiteSVG } from '../../utils/svgdata';
import stylesQrCom from './qrcom.module.css';


export default function QrHeader({ title, clearStorePaymentOrder }: { title: string, clearStorePaymentOrder :()=> void }) {


  const handleRedirectBack = () => {
    clearStorePaymentOrder();
    window.history.back();
  }

  return (
     <div className={clsx(stylesQrCom.flexStyle, stylesQrCom.bgcolor, stylesQrCom.justifyContentStart, stylesQrCom.gap10, stylesQrCom.flexDirecRow, stylesQrCom.p1415)}>
        <div className={clsx(stylesQrCom.fontColorWhite)} onClick={handleRedirectBack}>
            <LeftArrowWhiteSVG width={24} height={24} />
        </div>
        <div className={clsx(stylesQrCom.fontColorWhite)}>
            <span className={clsx(stylesQrCom.fontColorWhite, stylesQrCom.fontWeight500, stylesQrCom.lineHeight20, stylesQrCom.fontSize16)}>{title}</span>
        </div>
     </div>
  )
}
